import type { User } from '@/core/services/types/getAuthMe/responseTypes'

export const isUserInLoyaltySpecialsSegment = (user: User | null | undefined): boolean => {
  const edges = user?.userVariants?.edges ?? []
  return edges.some((edge) => edge.node.variant === 'loyalty-specials')
}
